export namespace DiscussionEnum {
    export enum Location {
        Internal = 100000000,
        External = 100000001
    }
    export enum Type {
        Document = 100000001,
        Status = 100000002,
        Comment = 100000000
    }
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/enums/discussion.enum.ts